export const toDate = (date, time) => new Date(`${date}T${(time || "09:00")}:00`);

export const fmtDate = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const fmtTime = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
};

// kind + status -> hex colours (iClean brand: orange jobs, teal shifts)
export const eventColors = (kind, status) => {
  if (status === "cancelled") return { bg: "#e2e8f0", border: "#94a3b8", text: "#475569" };
  if (status === "completed") return { bg: "#cbd5e1", border: "#64748b", text: "#334155" };
  if (kind === "job") {
    return status === "active"
      ? { bg: "#EA731D", border: "#16a34a", text: "#ffffff" }
      : { bg: "#EA731D", border: "#D9640F", text: "#ffffff" };
  }
  // shift
  return status === "active"
    ? { bg: "#0d9488", border: "#16a34a", text: "#ffffff" }
    : { bg: "#0d9488", border: "#0f766e", text: "#ffffff" };
};

export const STATUSES = ["scheduled", "active", "completed", "cancelled"];
export const WEEKDAYS = [6, 0, 1, 2, 3, 4, 5]; // values Mon=0..Sun=6, displayed Sunday-first
